export default "__VITE_ASSET__f362f338__"